import { z } from 'zod'

// Spatial classification — shared by Route and Track.
//
// Axis A: Region = administrative attribution (country / province / city / district).
// Axis B: NaturalFeatures = natural geography (mountain / lake / river / …).

export const Region = z.object({
  country: z.string().min(1).max(64),
  province: z.string().max(64).optional(),
  city: z.string().max(64).optional(),
  district: z.string().min(1).max(64).optional(),
})
export type Region = z.infer<typeof Region>

export const NaturalFeatureKind = z.enum([
  'mountain',
  'lake',
  'river',
  'waterfall',
  'pass',
  'other',
])
export type NaturalFeatureKind = z.infer<typeof NaturalFeatureKind>

export const NaturalFeature = z.object({
  kind: NaturalFeatureKind,
  name: z.string().min(1).max(64),
})
export type NaturalFeature = z.infer<typeof NaturalFeature>

export const NaturalFeatures = z.array(NaturalFeature).max(16)
export type NaturalFeatures = z.infer<typeof NaturalFeatures>
